import { basenameFind, getMetaFromJcamp, getTargetProperty, } from "../common.js";
const hgPorosimetry = {
    jpath: ['spectra', 'hgPorosimetry'],
    find: basenameFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default hgPorosimetry;
//# sourceMappingURL=hgPorosimetry.js.map